<div
  class="record-slider"
  [class.featured]="featured"
  [class.record-slider--card-display]="useCardDisplay"
  [class.slider-arrows-card-display]="useCardDisplay">
  <div class="record-slider__top">
    <div class="record-slider__header">
      <div class="record-slider__header__title">
        <ng-container [ngTemplateOutlet]="title.templateRef"></ng-container>
      </div>

      <div *ngIf="showActions" class="record-slider__header__actions">
        <ng-container [ngTemplateOutlet]="actions.templateRef"></ng-container>
      </div>
    </div>

    <div *ngIf="showSubheader" class="record-slider__subheader">
      <ng-container [ngTemplateOutlet]="subheader.templateRef"></ng-container>
    </div>
  </div>

  <opac-swiper [configuration]="swiperConfig">
    <opac-swiper-item *ngFor="let item of items; let i = index">
      <app-slider-list-item
        *ngIf="item.useMulticover"
        [item]="item"
        [active]="selectedItemIndex === i"
        [visible]="true"
        opacViewportObserver
        (keydown.enter)="onSwiperItemClicked(i)"
        (clicked)="onSwiperItemClicked(i)"
      ></app-slider-list-item>

      <app-slider-collection-item
        *ngIf="!item.useMulticover"
        [class.selected-item]="selectedItemIndex === i"
        [item]="item"
        [active]="selectedItemIndex === i"
        [visible]="true"
        opacViewportObserver
        (keydown.enter)="onSwiperItemClicked(i)"
        (keydown.space)="onSwiperItemClicked(i)"
        (clicked)="onSwiperItemClicked(i)">
      </app-slider-collection-item>
    </opac-swiper-item>
  </opac-swiper>
</div>
